const { MapTableBase } = require('./base.class');
const { identifiers, joiValidateObj } = require('../datastructComponents');
const Joi = require('joi');
const { STATES, LIBRARY_TYPES, USER_TYPES } = require('@bcm/constants');

const schema = {
  identifier: Joi.any().optional(),
  eocId: Joi.string().required(),
  ownerType: Joi.string().valid( ...Object.keys(USER_TYPES) ).required(),
  libraryId: Joi.string().required(),
  libraryName: Joi.string().required(),
  canEdit: Joi.boolean().required(),
  eocState: Joi.string().valid( ...Object.keys(STATES) ).required(),
  libraryState: Joi.string().valid( ...Object.keys(STATES) ).required(),
  libraryType: Joi.string().valid( ...Object.keys(LIBRARY_TYPES) ).required(),
};

class EocsToLibraries extends MapTableBase {
  constructor ( obj ) {
    joiValidateObj(schema, obj);
    super (
      identifiers.eocsToLibraries.buildPk(obj.eocState, obj.eocId),
      identifiers.eocsToLibraries.buildSk(obj.libraryState, obj.libraryType, obj.libraryId),
      identifiers.eocsToLibraries.buildGsiPk(obj.libraryState, obj.libraryType, obj.libraryId),
      identifiers.eocsToLibraries.buildGsiSk(obj.eocState, obj.eocId),
    );
    for (const key of Object.keys(obj)) {
      if(obj[key] || obj[key] === false) {
        this[key] = obj[key];
      }
    }
  }
}

exports.EocsToLibraries = EocsToLibraries;
exports.eocsToLibrariesSchema = schema;
